import { ChangeEvent, useEffect, useState } from 'react';
import { FilterStatusesDropListData } from '../filter-statuses.types';
import useEventDescriptionsUtils from '../../../../../hooks/use-event-descriptions-utils';
import { getGroupedEvents } from '../utils';

const useFilteredDropListData = (dropListData: FilterStatusesDropListData[]) => {
  const [inputValue, setInputValue] = useState('');
  const [filteredDropListData, setFilteredDropListData] = useState<FilterStatusesDropListData[]>(dropListData);

  const { getAppStatusTextById } = useEventDescriptionsUtils();

  const groupedEvents = getGroupedEvents(filteredDropListData);

  const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  useEffect(() => {
    if (!inputValue) {
      setFilteredDropListData(dropListData);
    }
    setFilteredDropListData(
      dropListData.filter(item => {
        const { appStatusText } = getAppStatusTextById(item.uds_fahrzeugbestellungeneventdescriptionid);
        return (
          appStatusText.toLowerCase().includes(inputValue.toLowerCase()) ||
          item.uds_app_status_filter_value?.label.toLowerCase().includes(inputValue.toLowerCase())
        );
      })
    );
  }, [inputValue]);

  return { groupedEvents, onChangeHandler, inputValue };
};

export default useFilteredDropListData;
